const trimTrailingSlash = (value: string) => value.replace(/\/+$/, '');

export const apiBaseUrl = trimTrailingSlash(
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000'
);

export const certificateBaseUrl = trimTrailingSlash(
  process.env.REACT_APP_CERTIFICATE_BASE_URL || 'http://localhost:3000'
);

export const brand = {
  companyName: 'PT GEMA INOVASI AGRI',
  colors: {
    primary: '#2D6237',
    secondary: '#668E1F',
    accent: '#D17A1F',
  },
};
